import React, { Children } from 'react';
import { Switch } from 'react-router-dom';
import { WizardContext } from '../contexts';
import { useWizard } from './useWizard';

export type WizardProviderProps = {
  children: React.ReactNode;
};

const WizardProvider = ({ children }: WizardProviderProps): JSX.Element => {
  const totalSteps = Children.count(children);
  const wizardContext = useWizard({ totalSteps });

  return (
    <WizardContext.Provider value={wizardContext}>
      <Switch>{children}</Switch>
    </WizardContext.Provider>
  );
};

export { WizardProvider };
